<template>
  <div>
    <a-form class="mb-3" :form="form" @submit="handleSubmit">
      <p class="neo_form_sub_heading">Academic Details</p>
      <div class="row pb-3">
        <div class="col-md-4">
          <a-form-item label="Name of the Board">
            <a-input
              placeholder="Name of the Board"
              v-decorator="['board', {rules: [{ required: true, message: 'Please input board name!' }]}]"
            />
          </a-form-item>
        </div>
        <div class="col-md-4">
          <a-form-item label="Board roll no">
            <a-input
              placeholder="Board roll no"
              v-decorator="['board_roll_no', {rules: [{ required: true, message: 'Please input board roll no!' }]}]"
            />
          </a-form-item>
        </div>
        <div class="col-md-4"></div>

        <div class="col-md-3">
          <a-form-item
            label="Result Status"
          >
            <a-radio-group
              v-decorator="[
                'result_status',
                {rules: [{ required: false, message: 'Please select a gender!' }],
                initialValue: 0},
              ]"
            >
              <a-radio  :value="0" class="mr-2">
                <span class="text-bold">Awaited</span>
              </a-radio>
              <a-radio  :value="1" class="mr-2">
                <span class="text-bold">Declared</span>
              </a-radio>
            </a-radio-group>
          </a-form-item>
        </div>

        <div class="col-md-4">
          <a-form-item label="Year of passing">
            <a-input
              placeholder="Year of passing"
              v-decorator="['year_of_passing', {rules: [{ required: true, message: 'Please input year of passing!', pattern: new RegExp(`^[0-9]{4}$`) }]}]"
            />
          </a-form-item>
        </div>

      </div>

      <a-divider />
      <p class="font-weight-bold mt-3">Exam score (Applicable if exam is already declared)</p>

      <div>
        <vue-custom-scrollbar class="scroll-area">
          <table class="table table-bordered">
            <thead>
              <tr>
                <th scope="col">#</th>
                <th scope="col">Subject</th>
                <th scope="col">Score</th>
                <th scope="col">Full Mark</th>
                <th scope="col">Status</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="marksGroup in marksGroups" :key="marksGroup">
                <th>
                  <div class="mt-1">
                    <button v-if="marksGroup > 0" class="btn btn-danger" v-on:click.prevent="handleRemoveMark(marksGroup)">
                      <i class="btn-addon-icon fe fe-trash-2" />
                    </button>
                  </div>
                </th>
                <td scope="row">
                  <a-form-item>
                    <a-input
                      size="large"
                      style="min-width: 10rem;"
                      placeholder="Subject name"
                      v-decorator="[`marks[${marksGroup}][subject]`, {rules: [{ required: false, message: 'Please input subject name!'}]}]"
                    />
                  </a-form-item>
                </td>
                <td>
                  <a-form-item>
                    <a-input
                      size="large"
                      style="min-width: 7rem;"
                      placeholder="Score"
                      v-decorator="[`marks[${marksGroup}][score]`, {rules: [{ required: false, message: 'Please input a valid score!', pattern: new RegExp(`^[0-9]*$`)}]}]"
                    />
                  </a-form-item>
                </td>
                <td>
                  <a-form-item>
                    <a-input
                      size="large"
                      style="min-width: 7rem;"
                      placeholder="Full marks"
                      v-decorator="[`marks[${marksGroup}][full_mark]`, {rules: [{ required: false, message: 'Please input a valid score!', pattern: new RegExp(`^[0-9]*$`)}]}]"
                    />
                  </a-form-item>
                </td>
                <td>
                  <a-form-item>
                    <a-select
                      size="large"
                      style="min-width:7rem;"
                      v-decorator="[`marks[${marksGroup}][status]`, {rules: [{ required: false, message: 'Please input a status!'},], initialValue: 1}]"
                    >
                      <a-select-option :value="1">
                        Pass
                      </a-select-option>
                      <a-select-option :value="0">
                        Fail
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </td>
              </tr>
            </tbody>
          </table>
        </vue-custom-scrollbar>

        <div class="mb-3">
          <button class="btn btn-sm btn-outline-primary " v-on:click.prevent="addMoreMarks">
            + Add more subjects
          </button>
        </div>
      </div>
      <a-divider />
      <div class="row my-3">
        <div class="col-lg-2 col-md-3 col-sm-4">
          <a-form-item label="PC Score">
            <a-input
              placeholder="PC Score"
              addon-after="%"
              v-decorator="[`pc_score`, {rules: [{ required: false, message: 'Please input a valid pc score!', pattern: new RegExp(`^[0-9]*$`)}]}]"
            />
          </a-form-item>
        </div>
        <div class="col-lg-2 col-md-3 col-sm-4">
          <a-form-item label="Grade">
            <a-input
              placeholder="Grade"
              v-decorator="[`grade`, {rules: [{ required: false, message: 'Please input a grade!',}]}]"
            />
          </a-form-item>
        </div>
      </div>

      <a-divider />
      <p class="font-weight-bold mt-3">Extra curricular (if any / lastest two / most significant two)</p>

      <div class="mb-3">
        <vue-custom-scrollbar class="scroll-area">
          <table class="table table-bordered">
            <thead>
              <tr>
                <th scope="col">#</th>
                <th scope="col">Name</th>
                <th scope="col">Received when</th>
                <th scope="col">Received for</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="index in extraCurriculars" :key="index">
                <th>
                  <div class="mt-1">
                    {{ index }}
                  </div>
                </th>
                <td scope="row">
                  <a-form-item>
                    <a-input
                      size="large"
                      style="min-width: 10rem;"
                      placeholder="Name"
                      v-decorator="[`ec${index}_name`, {rules: [{ required: false, message: 'Please input a name!'}]}]"
                    />
                  </a-form-item>
                </td>
                <td>
                  <a-form-item>
                    <a-input
                      size="large"
                      style="min-width: 7rem;"
                      placeholder="Year"
                      v-decorator="[`ec${index}_when`, {rules: [{ required: false, message: 'Please input a valid year!', pattern: new RegExp(`^[0-9]{4}$`)}]}]"
                    />
                  </a-form-item>
                </td>
                <td>
                  <a-form-item>
                    <a-input
                      size="large"
                      style="min-width: 10rem;"
                      placeholder="Received for"
                      v-decorator="[`ec${index}_for`, {rules: [{ required: false, message: 'Please input a valid score!',}]}]"
                    />
                  </a-form-item>
                </td>
              </tr>
            </tbody>
          </table>
        </vue-custom-scrollbar>
      </div>

      <a-divider />
      <p class="font-weight-bold mt-3">Last school / institute details</p>
      <div class="row">
        <div class="col-lg-6 col-md-8">
          <a-form-item label="School name">
            <a-input
              placeholder="School name"
              v-decorator="[`last_school_name`, {rules: [{ required: true, message: 'Please input school name!'}]}]"
            />
          </a-form-item>
        </div>
        <div class="col-lg-4 col-md-4">
          <a-form-item label="School Type">
            <a-select
              v-decorator="[`last_school_type`, {rules: [{ required: false, message: 'Please input a type!'},], initialValue: 'private'}]"
            >
              <a-select-option value="private">
                Private
              </a-select-option>
              <a-select-option value="government">
                Government
              </a-select-option>
            </a-select>
          </a-form-item>
        </div>
        <div class="col-lg-4 col-md-4">
          <a-form-item label="Medium of study">
            <a-input
              placeholder="English / Manipuri / .."
              v-decorator="[`last_school_medium`, {rules: [{ required: false, message: 'Please input study medium!'}]}]"
            />
          </a-form-item>
        </div>
      </div>

      <div v-if="applicationFormData.subject_groups.length" class="mb-3">
        <a-divider />
        <p class="font-weight-bold mt-3">Select grouping opted for admission</p>

        <div>
          <a-form-item label="Select a subject group">
            <a-radio-group
              v-decorator="[`subject_group_id`, {rules: [{ required: true, message: 'Please select a subject group!'}]}]"
            >
              <a-radio
                class="d-block mt-3"
                v-for="subjectGroup in applicationFormData.subject_groups"
                :key="subjectGroup.id"
                :value="subjectGroup.id"
              >
                <span v-for="(subject, index) in subjectGroup.subjects" :key="subject.id">
                  {{ getSubjectName(subject, index, subjectGroup.subjects.length) }}
                </span>
              </a-radio>
            </a-radio-group>
          </a-form-item>
        </div>
      </div>

      <a-divider />

      <div class="row mt-3">
        <div class="col-md-6">
          <a-button
            type="primary"
            size="large"
            class="text-center btn btn-dark font-weight-bold font-size-18 mt-2"
            v-on:click.prevent="handlePrevious"
          >Previous</a-button>
        </div>
        <div class="col-md-6 text-md-right">
          <a-button
            type="primary"
            htmlType="submit"
            size="large"
            class="text-center btn btn-primary font-weight-bold font-size-18 mt-2"
          >Save & Next</a-button>
        </div>
      </div>

    </a-form>
  </div>
</template>

<script>
import moment from 'moment'
import { isEqual } from 'lodash'
import { mapState } from 'vuex'
import { makeFields } from './fields'

import vueCustomScrollbar from 'vue-custom-scrollbar'

export default {
  name: 'FormStepThree',
  props: ['applicantData', 'applicationFormData'],
  components: {
    vueCustomScrollbar,
  },
  mounted() {
    this.setFormData()
  },
  data() {
    return {
      form: this.$form.createForm(this),
      dateFormat: 'DD-MM-YYYY',
      marksGroups: [ 0, 1, 2 ],
      marksGroupCounter: 2,
      extraCurriculars: [ 1, 2 ],
    }
  },
  computed: {
    ...mapState(['applicant']),
  },
  methods: {
    moment,
    disabledDate(current) {
      // Can not select days after today
      return current > moment().endOf('day')
    },
    handlePrevious() {
      this.$emit('previous', 2)
    },
    addMoreMarks() {
      if (this.marksGroups.length < 12) {
        this.marksGroupCounter = this.marksGroupCounter + 1
        this.marksGroups.push(this.marksGroupCounter)
      }
    },
    handleRemoveMark(index) {
      this.marksGroups = this.marksGroups.filter(value => value !== index)
    },
    getSubjectName(subject, index, subjectsLength) {
      if (index < subjectsLength - 1) {
        return subject.name + ', '
      }
      return subject.name
    },
    handleSubmit(e) {
      e.preventDefault()
      this.loading = true
      this.form.validateFieldsAndScroll((err, values) => {
        if (!err) {
          this.$confirm({
            title: `Are you sure?`,
            content: `Click on the OK button to save your academic data.`,
            onOk: () => {
              if (values.marks) {
                values.marks = values.marks.filter(item => item && isEqual(item, { status: 1 }))
                values.token = this.applicant.app_form_token
              }
              this.$http
                .patch(`/api/application-form/academic/${this.applicantData.id}`, values)
                .then(({ data }) => {
                  if (data.type === 'error') {
                    this.$applicantAuth.logout()
                  } else {
                    this.$emit('saved')
                    this.loading = false
                    this.$notification['success']({
                      message: 'Successfully saved!',
                      description: `Your academic data has been saved successfully!`,
                    })
                  }
                })
                .catch(error => {
                  this.loading = false
                  this.$neoNotify.error(error)
                })
            },
            onCancel: () => {
              this.loading = false
            },
          })
        }

        this.loading = false
      })
    },
    setFormData() {
      const fieldsData = makeFields(this.applicantData)

      this.marksGroupCounter = this.applicantData.applicant_marks.length > 2 ? this.applicantData.applicant_marks.length - 1 : 2
      if (this.applicantData.applicant_marks.length) {
        this.marksGroups = this.applicantData.applicant_marks.map((element, index) => {
          return index
        })
      }

      this.$nextTick(() => {
        this.form.setFieldsValue({ ...fieldsData })
      })
    },
  },
}
</script>

<style>

</style>
